module.exports = __webpack_public_path__ + "static/doordash-white-55169c482d7c4c94d29f2846dee0606b.png";